export function when (condition, callback, fallback) {
  return condition ? callback() : fallback();
}


// WEBPACK FOOTER //
// ./scripts/vue/services/functional.js